import { PoiSearchEnum } from "../enums/poi-search-enum";
import { ArcGisPOIColumn } from "./arcgis-poi-column.model";
export const POISearchColumnToArcGisColumnPOIsLookup = new Map([
    [PoiSearchEnum.name, ArcGisPOIColumn.Name],
    [PoiSearchEnum.alternativeName, ArcGisPOIColumn.AlternativeName],
    [PoiSearchEnum.type, ArcGisPOIColumn.Type],
    [PoiSearchEnum.address, ArcGisPOIColumn.Address],
    [PoiSearchEnum.ward, ArcGisPOIColumn.Ward],
]);
